var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.priorityName)?_c('el-tag',{attrs:{"size":"medium","type":_vm.cssClass}},[_c('i',{staticClass:"fas fa-bolt"}),_vm._v("\n  "+_vm._s(_vm.priorityName)+"\n")]):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b70b152","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/common/doc-priority-tag.vue
// module id = vBeN
// module chunks = 89